module.exports = __webpack_public_path__ + "img/ps-50.3f455cbd.jpg";